import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-fill d-inline-flex gap-3" }
const _hoisted_2 = { class: "flex-fill d-inline-flex gap-3" }
const _hoisted_3 = { class: "flex-fill d-inline-flex gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormField = _resolveComponent("FormField")!
  const _component_States = _resolveComponent("States")!
  const _component_Countries = _resolveComponent("Countries")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["d-flex flex-column mb-10", _ctx.containerClass])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_FormField, {
        required: true,
        name: _ctx.addPrefix('address_line', _ctx.prefix),
        containerClass: "flex-fill w-100",
        label: "Business / Office Address",
        placeholder: "Business / Office Address",
        type: "text"
      }, null, 8, ["name"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FormField, {
        required: true,
        name: _ctx.addPrefix('city', _ctx.prefix),
        containerClass: "flex-fill w-50",
        label: "Suburb",
        placeholder: "Suburb",
        type: "text"
      }, null, 8, ["name"]),
      _createVNode(_component_States, {
        required: true,
        options: _ctx.options,
        value: _ctx.state,
        name: _ctx.addPrefix('state', _ctx.prefix),
        containerClass: "flex-fill w-50",
        onChange: _ctx.handleStateSelect,
        onClose: _ctx.handleStateClose
      }, null, 8, ["options", "value", "name", "onChange", "onClose"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_FormField, {
        required: true,
        name: _ctx.addPrefix('post_code', _ctx.prefix),
        mask: '####',
        containerClass: "flex-fill w-50",
        label: "Postcode",
        placeholder: "Postcode",
        type: "text"
      }, null, 8, ["name"]),
      _createVNode(_component_Countries, {
        required: true,
        value: _ctx.country,
        options: _ctx.countries,
        name: _ctx.addPrefix('country', _ctx.prefix),
        label: "Country",
        containerClass: "flex-fill w-50",
        onChange: _ctx.handleCountrySelect,
        onClose: _ctx.handleCountryClose
      }, null, 8, ["value", "options", "name", "onChange", "onClose"])
    ])
  ], 2))
}